import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GiftCardPill from 'components/giftcard/giftCardPill';
import AmenitiesList from 'components/facility/AmenitiesList/AmenitiesList';
import { Text } from 'components/core/Typography';
import { IconText } from 'components/core/IconText';
import { formatUnitSize } from 'utils/unitNameTrim';
import elipseIcon from 'assets/images/Ellipse.svg';

import './unitDescriptionV2.scss';

export default function UnitDescriptionV2({
	className,
	unitSize,
	unitType,
	amenitiesText,
	promotion,
	vehicleAccommodation,
	giftCardOffer,
	pricePerSqft,
	onToggleAmenities,
	showAllAmenities,
}) {
	const { withIcons, withoutIcons, AllAmenities } = AmenitiesList({
		amenitiesList: amenitiesText,
	});

	return (
		<div className={classnames('unit-description-content', className)}>
			<div className="unit-name-price-container">
				<Text
					className="unit-size-label-description-content"
					size="small"
				>
					{formatUnitSize(unitSize)}
					<span className="unit-type-content">{unitType}</span>{' '}
					{giftCardOffer?.isGiftCardEligible && (
						<GiftCardPill
							giftCardValue={giftCardOffer?.giftCardValue}
						/>
					)}
				</Text>
				{!!vehicleAccommodation && (
					<Text
						size="tiny"
						className="vehicle-accommodation"
					>
						{vehicleAccommodation}
					</Text>
				)}
				{!!pricePerSqft && (
					<Text className="price-per-sqft-content">
						${pricePerSqft} / sqft
					</Text>
				)}
			</div>
			<div className="unit-promotion-amenities-container">
				{!!promotion && (
					<Text
						color="green"
						className="unit-promotion-content"
						last
					>
						{promotion}
					</Text>
				)}
				<div>
					{AllAmenities?.length > 0 && (
						<div>
							<p className='unit-card-feature-heading'>Features</p>
							<div className="amenities-with-icon">
								{AllAmenities?.slice(0, 5)?.map((amenity) => (
									<div
										key={amenity?.key}
										className="amenities-with-icon-item"
									>
										{amenity?.name}
									</div>
								))}
							</div>
						</div>
					)}
					{AllAmenities?.length > 5 && (
						<div
							className="toggle-amenities amenities-with-icon-item"
							onClick={onToggleAmenities}
						>
							+ {AllAmenities?.length - 5} Amenities
						</div>
					)}
					{showAllAmenities &&AllAmenities?.length > 5 && (
						<div className="all-amenities-list">
							{AllAmenities?.slice(5)?.map((amenity, index, arr) => (
								<React.Fragment key={amenity?.key}>
									<span>{amenity?.name}</span>
									{index < arr.length - 1 && (
										<img
											src={elipseIcon}
											alt="elipse"
										/>
									)}
								</React.Fragment>
							))}
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

UnitDescriptionV2.propTypes = {
	className: PropTypes.string,
	unitSize: PropTypes.string.isRequired,
	unitType: PropTypes.string.isRequired,
	promotion: PropTypes.node,
	amenitiesText: PropTypes.string,
	vehicleAccommodation: PropTypes.string,
	tierDescription: PropTypes.string,
	giftCardOffer: PropTypes.object,
	pricePerSqft: PropTypes.string,
};
